import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AnnotationComponent } from './annotation/annotation.component';
import { AnnotationToolsComponent } from './annotation/annotation-tools.component';
import { AnnotationLayerComponent } from './annotation/annotation-layer.component';
import { AnnotationModalComponent } from './annotation/annotation-modal.component';
@NgModule({
  declarations: [AnnotationComponent, AnnotationLayerComponent, AnnotationToolsComponent, AnnotationModalComponent],
  imports: [CommonModule, FormsModule],
  exports: [AnnotationComponent, AnnotationLayerComponent, AnnotationToolsComponent, AnnotationModalComponent]
})
export class AnnotationModule {}
